import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-center font-bold mb-5" }, "All users", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_GoBack = _resolveComponent("GoBack")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_GoBack),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_a_table, {
            dataSource: _ctx.users,
            columns: _ctx.columns,
            pagination: false
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.key === 'name')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({ 'font-bold text-green-600': record.role === 'admin' })
                  }, _toDisplayString(record.name), 3))
                : _createCommentVNode("", true),
              (column.key === 'email')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass({ 'font-bold text-green-600': record.role === 'admin' })
                  }, _toDisplayString(record.email), 3))
                : _createCommentVNode("", true),
              (column.key === 'role')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: _normalizeClass({ 'font-bold text-green-600': record.role === 'admin' })
                  }, _toDisplayString(record.role), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["dataSource", "columns"])
        ]))
      : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
  ], 64))
}